import type {
  AppSetting,
  AppSettingList,
  CreateAppSettingInput,
  UpdateAppSettingInput,
  CreateAppSettingListInput,
  UpdateAppSettingListInput,
} from '@peles/shared';
import { apiClient } from './client';

// ─── App Settings ───────────────────────────────────────────────────────────

export async function fetchAppSettings(): Promise<AppSetting[]> {
  const { data } = await apiClient.get<AppSetting[]>('/settings/app-settings');
  return data;
}

export async function fetchAppSettingByVarCode(varCode: string): Promise<AppSetting> {
  const { data } = await apiClient.get<AppSetting>(`/settings/app-settings/${varCode}`);
  return data;
}

export async function createAppSetting(input: CreateAppSettingInput): Promise<AppSetting> {
  const { data } = await apiClient.post<AppSetting>('/settings/app-settings', input);
  return data;
}

export async function updateAppSetting(
  id: string,
  updates: UpdateAppSettingInput,
): Promise<AppSetting> {
  const { data } = await apiClient.patch<AppSetting>(`/settings/app-settings/${id}`, updates);
  return data;
}

export async function deleteAppSetting(id: string): Promise<void> {
  await apiClient.delete(`/settings/app-settings/${id}`);
}

// ─── App Setting Lists ──────────────────────────────────────────────────────

export async function fetchAppSettingLists(): Promise<AppSettingList[]> {
  const { data } = await apiClient.get<AppSettingList[]>('/settings/app-setting-lists');
  return data;
}

export async function createAppSettingList(
  input: CreateAppSettingListInput,
): Promise<AppSettingList> {
  const { data } = await apiClient.post<AppSettingList>('/settings/app-setting-lists', input);
  return data;
}

export async function updateAppSettingList(
  id: string,
  updates: UpdateAppSettingListInput,
): Promise<AppSettingList> {
  const { data } = await apiClient.patch<AppSettingList>(
    `/settings/app-setting-lists/${id}`,
    updates,
  );
  return data;
}

export async function deleteAppSettingList(id: string): Promise<void> {
  await apiClient.delete(`/settings/app-setting-lists/${id}`);
}
